import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as formActions } from 'react-redux-form';
import ibanActions from 'actions/ibanActions';
import preLoaderActions from 'actions/preLoaderActions';
import OKIbanActions from 'ok-iban/dist/actions/OKIban';
import identityValidationActions from 'actions/identityValidationActions';
import optionsActions from 'actions/optionsActions';
import { IbanValidation } from './IbanValidation';

const IbanValidationContainerComponent = props => {
    return <IbanValidation {...props} />;
};

const mapStateToProps = state => {
    return {
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        options: state.options,
        immStepsState: state.steps,
        immIban: state.iban,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        formActions: bindActionCreators(formActions, dispatch),
        identityValidationActions: bindActionCreators(identityValidationActions, dispatch),
        optionsActions: bindActionCreators(optionsActions, dispatch),
        ibanActions: bindActionCreators(ibanActions, dispatch),
        OKIbanActions: bindActionCreators(OKIbanActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
    };
};

export const IbanValidationContainer = connect(mapStateToProps, mapDispatchToProps)(IbanValidationContainerComponent);
